import { Badge, ErrorMessage, Spinner } from "../../../../widgets";

import { FC } from "react";
import { FetchStatus } from "../../../../base/types";
import { IControlAttributes } from "../../../../base/models";
import { useBadgeProperties } from "./BadgeProperties";

export const DraftBadgeComponent: FC<IControlAttributes> = ({
    control, className, children, props, designerMode, ...rest
}) => {
    const { status, error, properties, draftText } = useBadgeProperties(props);

    switch (status) {
        case FetchStatus.Idle: return <></>
        case FetchStatus.Loading: return <Spinner show={true} />
        case FetchStatus.Error: return <ErrorMessage message={error} />
    }

    return (
        <div className={"inline-block position-relative"}>
            <Badge
                className={"position-absolute top-0 end-0 text-nowrap fs-9 rounded-0"}
                badgeStyle="primary">
                Badge
            </Badge>
            <Badge className={className} iconClassName="me-1" {...properties} text={draftText}>
                {children}
            </Badge>
        </div>)
}
